import { html } from "lit";
var icon_trash_default = () => html`
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
    <path
      fill-rule="evenodd"
      d="M23.01 27.203a.672.672 0 01-.658.628H9.732a.675.675 0 01-.658-.628L8.351 9.846a.986.986 0 00-1.97.082l.723 17.357a2.645 2.645 0 002.628 2.518h12.62a2.645 2.645 0 002.628-2.518l.723-17.357a.986.986 0 10-1.97-.082l-.723 17.357zm-10.7-2.307a.79.79 0 001.577-.046l-.394-13.408a.79.79 0 00-1.577.046l.394 13.408zm5.888-.046a.79.79 0 001.576.046l.395-13.408a.79.79 0 00-1.577-.046l-.394 13.408zM17.82 2.197c1.201 0 2.373.884 2.703 2.039l.376 1.313H25.9a.986.986 0 010 1.972H6.183a.986.986 0 010-1.972h5.003l.375-1.313c.33-1.154 1.503-2.039 2.703-2.039zm0 1.972h-3.556c-.32 0-.719.3-.807.609l-.22.771h5.61l-.22-.771c-.088-.308-.486-.609-.807-.609z" />
  </svg>
`;
export {
  icon_trash_default as default
};
//# sourceMappingURL=icon-trash.js.map
